// extracted by mini-css-extract-plugin
export default {"custom-toggle":"styles_custom-toggle__NYe8V","ant-switch-checked":"styles_ant-switch-checked__F1GMi"};